import React from 'react';

import IconArrow from '../icons/IconArrow';

import './index.css';

const MainHeader = ({title, backLink}) => {

  return (
    <header className="main__header">
      {backLink 
        ? (
          <h2 className="header__title">
            <span className="header__backlink" onClick={() => window.history.go(-1)}>
              <IconArrow />
            </span>
            <span className="header__title-text">
              {title}
            </span>
          </h2>
        )
        : <h2 className="header__title">{title}</h2>
      }
    </header>
  );
}

export default MainHeader;
